import { useEffect, useState } from "react";
import { Mail, RefreshCw } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

const COLOR = { accepted: "bg-slate-100 text-slate-700", sent: "bg-sky-100 text-sky-800", delivered: "bg-emerald-100 text-emerald-800", opened: "bg-emerald-100 text-emerald-800", clicked: "bg-emerald-100 text-emerald-800",
  delivery_delayed: "bg-amber-100 text-amber-800", bounced: "bg-red-100 text-red-800", complained: "bg-red-100 text-red-800", failed: "bg-red-100 text-red-800" };
const LABEL = { accepted: "accettata", sent: "inviata", delivered: "consegnata", opened: "aperta", clicked: "cliccata", delivery_delayed: "in ritardo", bounced: "rimbalzata", complained: "reclamo", failed: "fallita" };
const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "—");

export const EmailDeliveries = () => {
  const [d, setD] = useState(null);
  const load = async () => { try { setD((await api.get("/superadmin/email-deliveries")).data); } catch { setD({ error: true }); } };
  useEffect(() => { load(); }, []);
  if (!d) return null;
  if (d.error) return <p className="text-sm text-red-600" data-testid="sa-email-deliveries-error">Consegne email non disponibili.</p>;
  const c = d.config;
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 space-y-3" data-testid="sa-email-deliveries">
      <div className="flex flex-wrap items-center gap-2">
        <Mail className="h-4 w-4 text-slate-600" />
        <h3 className="font-semibold text-slate-900 text-sm">Consegne email · ultime 24h</h3>
        <span className="text-xs text-slate-500" data-testid="sa-email-config">
          canale <b>{c.provider === "resend" ? "Resend (dominio proprio)" : "Emergent"}</b>{c.from_address ? ` · da ${c.from_address}` : ""}{c.reply_to ? ` · risposte a ${c.reply_to}` : ""} · webhook {c.webhook_configured ? "attivo" : "non configurato"}
        </span>
        <Button size="sm" variant="outline" onClick={load} className="ml-auto h-7" data-testid="sa-email-refresh"><RefreshCw className="h-3.5 w-3.5" /></Button>
      </div>
      <div className="flex flex-wrap gap-2 text-xs" data-testid="sa-email-counts">
        <span className="rounded-full bg-slate-900 text-white px-2.5 py-0.5">Totale {d.total}</span>
        {Object.entries(d.counts).map(([k, n]) => <span key={k} className={`rounded-full px-2.5 py-0.5 ${COLOR[k] || COLOR.accepted}`}>{LABEL[k] || k} {n}</span>)}
      </div>
      {!!d.problems.length && (
        <div className="rounded-lg border border-red-200 bg-red-50 p-2 text-xs space-y-1" data-testid="sa-email-problems">
          <b className="text-red-800">Rimbalzi e reclami recenti</b>
          {d.problems.slice(0, 10).map((p) => <div key={p.id} className="flex flex-wrap gap-2 text-red-900"><span>{fmt(p.sent_at)}</span><span>{p.to}</span><span className="text-red-700">{LABEL[p.status]}{p.error ? ` · ${p.error}` : ""}</span></div>)}
        </div>
      )}
      <div className="space-y-1 max-h-64 overflow-y-auto" data-testid="sa-email-items">
        {!d.items.length && <p className="text-xs text-slate-500">Nessun invio registrato.</p>}
        {d.items.map((i) => (
          <div key={i.id} className="flex flex-wrap items-center gap-2 text-xs">
            <span className="text-slate-500 w-28">{fmt(i.sent_at)}</span>
            <span className={`rounded-full px-2 py-0.5 ${COLOR[i.status] || COLOR.accepted}`}>{LABEL[i.status] || i.status}</span>
            <span className="text-slate-800">{i.to}</span>
            <span className="text-slate-500 truncate max-w-xs">{i.subject}</span>
            <span className="text-slate-400">{i.provider}{i.tenant_id ? ` · ${i.tenant_id}` : ""}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
